import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toLabel',
  standalone: true,
})
export class ToLabelPipe implements PipeTransform {
  // FIXME si un utilisateur peut voir un utilisateur mais ne peut pas voir
  // tous ses droits (par ex : chef de secteur Wanaka => conseiller Wanaka qui
  // est aussi admin => role admin pas vu), il y a des roles qui ne sont pas dans le dict.
  // a changer ?? récupérer tous les rôles est les afficher quand même
  transform(key: any, dict: Map<number | string, any>): string | string[] {
    if (key instanceof Array) {
      const values: string[] = key.map((i: any) => this.transform(i, dict) as string);
      return values.filter((v) => v && v.length > 0);
    } else {
      if (!dict || dict.size === 0) {
        return '';
      }
      const value = dict.get(key);
      if (value) {
        return dict.get(key).label;
      } else {
        return '';
      }
    }
  }
}
